export default function Header(el) {
    const desktopSearchFormWrapper = el.querySelector('.header__search-form-wrapper');
    const desktopSearchBtn = desktopSearchFormWrapper.querySelector('.search-btn');

    const mobileNavBtn = el.querySelector('.header__mobile .header__menu-toggle');
    const mobileNavElements = el.querySelector('.header__mobile .header__mobile-elements');
    const mobileNavOverlay = el.querySelector('.header__mobile .header__nav-overlay');
    const mobileNavBtns = el.querySelectorAll('.header__mobile .header__nav-primary > li > a > span');

    document.addEventListener('click', event => {
        // Toggle search field
        if (desktopSearchBtn.contains(event.target)) {
            desktopSearchFormWrapper.classList.add('header__search-form-wrapper--active');
        }

        if (!desktopSearchFormWrapper.contains(event.target)) {
            desktopSearchFormWrapper.classList.remove('header__search-form-wrapper--active');
        }
    });

    // Toggle mobile nav options
    mobileNavBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            btn.closest('li').classList.toggle('header__nav-active');
        });
    });

    mobileNavBtn.addEventListener('click', btn => {
        btn.target.parentNode.classList.toggle('header__menu-toggle--expanded');
        mobileNavElements.classList.toggle('header__mobile-elements--active');
        mobileNavOverlay.classList.toggle('active');
        document.body.classList.toggle('nav-overlay-active');
    });

    // highlight current page
    const currentPath = window.location.pathname;
    const links = el.querySelectorAll('a');
    links.forEach(node => {
        if (
            node.pathname.startsWith(currentPath)
            && currentPath !== '/'
        ) {
            node.classList.add('is-active');
        }
    });
}
